export default {
  state: {
    tabSecondName:'home',
    isCollapse: false,
    currentMenu: null,
    label:'首页',
    menu: [],
    tabsList: [
      {
        path: '/',
        name: 'home',
        label: '首页',
        icon: 'home'
      }
    ],
    //权限相关
    asideData:{},
    AuthorityButtonArr:[],
    AuthorityPageArr:[],

    overflowxHidden:false,
  },
  mutations: {
    selectMenu(state, val) {
      state.tabSecondName = val.name;
      if (val.name != 'home') {
        state.currentMenu = val;
        let result = state.tabsList.findIndex(item => item.name === val.name)
        result === -1 ? state.tabsList.push(val) : ''
        state.label = val.label;
      } else {
        state.currentMenu = null;
        state.label = '首页'
      }
      state.overflowxHidden = false;
      if(!this.currentTime){
        this.currentTime = setTimeout(()=>{
          state.overflowxHidden = true;
          this.currentTime = null;
        },1000)
      }

    },
    closeTab(state,val) {
      let result = state.tabsList.findIndex(item => item.name === val.name)
      state.tabsList.splice(result, 1)
    },
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse
    },
    resetTabsList(state){
      state.tabsList = [
        {
          path: '/',
          name: 'home',
          label: '首页',
          icon: 'home'
        }
      ]
      state.currentMenu = null;
      state.label = '首页'
    },
    setAsideData(state,val){
      console.log(1212212212211);
      console.log(val);
      state.asideData = val;
    },
    setAuthorityButtonArr(state,val){
      state.AuthorityButtonArr = val;
    },
    setAuthorityPageArr(state,val){
      state.AuthorityPageArr = val;
    },
  },
  actions: {}
}
